<template>
  <div v-if="canRender" style="flex:1 0 auto;position:relative;">
    <v-card class="ma-2 maincontent" >      
      <v-card-title style="flex-direction:column;align-items:stretch;height:100%;">
        <h2 v-if="showTitle" style="flex:0 0 auto;">{{title}}</h2>        
        <component ref="formComponent" :is="componentName" :config="config" />        
        <v-layout v-if="showActionArea" class="pt-2 adm-button" row wrap >
          <v-btn v-if="showDeleteAction && original.id" @click.prevent="remove">{{$t('Admin.Remove')}}<v-icon right>mdi-delete</v-icon></v-btn>          
          <v-btn @click.prevent="annuler">{{$t('Admin.Cancel')}}<v-icon right>mdi-restore</v-icon></v-btn>
          <v-btn @click.prevent="sauvegarde">{{$t('Admin.Save')}}<v-icon right>mdi-content-save</v-icon></v-btn>
        </v-layout>          
      </v-card-title>          
    </v-card> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import CheckUnsaveChange from '@/components/shared/CheckUnsaveChange'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import { VuetifyConfirmObject } from 'vuetify-confirm'



@Component({
  name: 'AdminForm', 
  props:{
    itemid:Number,
    config:{      
      default: () => {
        return {}
      }
    }
  }
})
export default class AdminForm<T extends AloDbBase> extends CheckUnsaveChange<T> {  
  itemid!:number
  showDeleteAction:boolean  = false
  canRender:boolean = true
  
  get itemTypeName(){
    return ""
  }

  get componentName() {
    return `Admin${this.itemTypeName}Form`
  }
 
  /*Cycle de vie*/
  created() {               
    //@ts-ignore
    this.$store.myActions[`${this.itemTypeName.toUpperCase()}_ENSURE_LIST`]().then(() => {this.$store.myActions[`${this.itemTypeName.toUpperCase()}_SELECT_DETAIL`](this.itemid)})    
  }

  @Watch('$route')
  onRouteChanged(to: string, oldVafroml: string) {
    //@ts-ignore
    //Force le reset du form avec un element nouveau puis lance la requete evite les bugs de reaffichage vue
    this.$store.myActions[`${this.itemTypeName.toUpperCase()}_SELECT_DETAIL`](-1);
    if(this.itemid != -1) {
      this.$nextTick(()=>{
        //@ts-ignore
        this.$store.myActions[`${this.itemTypeName.toUpperCase()}_SELECT_DETAIL`](this.itemid)
      })      
    }
  }

  get original(){
    //@ts-ignore
    return this.$store.myGetters[`originalAdm${this.itemTypeName}`] as T
  } 

  get modified()
  {
    //@ts-ignore
    return this.$store.myGetters[`modifiedAdm${this.itemTypeName}`] as T
  }

  get showTitle() {
    return true
  }
    
  get title(){
    return this.original.id! > 0?`${this.$t(`Admin.${this.itemTypeName}.Form.Modify`)} ${this.originalLibelle}`:this.$t(`Admin.${this.itemTypeName}.Form.New`)
  }

  get originalLibelle(){
    return this.original.libelle
  }

  get status():string{
    //@ts-ignore
    return this.$store.myGetters[`${camelCase(this.itemTypeName)}Status`]
  }

  get loading():boolean{
    //@ts-ignore
    return this.$store.myGetters[`${camelCase(this.itemTypeName)}Loading`]
  }

  get showActionArea() {
    return true
  }
  
  /*Fonctions*/  
  sauvegarde() {
    //@ts-ignore
    this.$store.myActions[`${this.itemTypeName.toUpperCase()}_SAVE_REQUEST`]()
  }
  
  annuler(){
    //@ts-ignore
     this.$store.myActions[`${this.itemTypeName.toUpperCase()}_CANCEL_MODIFIED_ADM`]()
  }

  remove(){
    this.$confirm(this.$t('Admin.DeleteDialogMessage').toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject).then((answer) => {
        if (answer) {
          //@ts-ignore
          this.$store.myActions[`${this.itemTypeName.toUpperCase()}_DELETE_REQUEST`]()
        } 
      })    
  }
}
</script>